export const PreviewLivePath =
  '/preview-live/:tenantId/:elearningId/:type/:frameId?';
